export const BACKEND_HOST = 'https://admin.poncore.com';
export const BACKEND_WEBSOCKET_HOST = 'wss://admin.poncore.com';
